import React from 'react';
import Table, { Ctd } from '../../table/Table';
import Button from '../../forms/Button';
import GetState from '../../GetState';
import { QuestRoute } from '../../api/QuestRoutes';
import { formatCurrency, generateId, translate } from '../../utility/functions';
import Form from '../../forms/Form';
import HamQuest from '../../api/HamQuestGiver';
import Input from '../../forms/Input';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import Preput from '../../forms/Preput';
import { userRoles } from '../../RoleProtected';
import ManagementRow from '../../table/ManagementRow';
import Checkbox from '../../forms/Checkbox';
import ModalFactory from '../../Modal';
import CheckMark from '../../CheckMark';

const Products = ({ ...props }) => {

    const FulfillmentForm = ({ values, editing }) => (
        <>
            <Checkbox
                label='Active'
                name='enabled'
            />
            <Input
                label='Name'
                name='name'
                required
            />
            <Select
                label='Item Type'
                name='appProductType'
                options={HSOptions.fulfillmentType}
                disabled={editing}
                required
            />
            <Input
                label='Price'
                name='price'
                type='price'
                callback={e => {
                    if (values.appProductType !== 'Merchandise' && values.value < e)
                        values.value = e
                }}
                required
            />
            <Input
                label='Value'
                name='value'
                type='price'
                min={values.price}
                disable={values.appProductType === 'Merchandise'}
                required
            />
            <Checkbox
                label='Is taxed'
                name='taxable'
            />
            <Preput
                label='Details'
                name='details'
            />
        </>
    )

    const [products, refreshProducts] = GetState(QuestRoute.fulfillment.products);

    const deleteProduct = (product) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${product.name}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Product',
                body: `Deleting ${product.name}`,
                callback: () => HamQuest.delete(QuestRoute.fulfillment.edit(product.appProductId))
            },
            confirmed: {
                title: 'Success',
                body: `${product.name} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshProducts()
        })
    }

    const editProduct = (product) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit Product`,
            body: (
                <Form
                    name='fulfillableSettings'
                    inputs={{ ...product }}
                    onSubmit={e => HamQuest.put(QuestRoute.fulfillment.edit(product.appProductId), { ...e })
                        .then(() => {
                            refreshProducts();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    {({ values }) => <FulfillmentForm values={values} editing />}
                </Form>
            )
        })
    }

    const addNewProduct = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add a new Product`,
            body: (
                <Form
                    name='fulfillableSettings'
                    inputs={{
                        enabled: '',
                        name: '',
                        appProductType: '',
                        price: '',
                        value: '',
                        details: '',
                        taxable: false,
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.fulfillment.products, { ...e })
                        .then(() => {
                            refreshProducts();
                            ModalFactory.close(id);
                        })
                    }
                    text='Add Product'
                >
                    {({ values }) => <FulfillmentForm values={values} />}
                </Form>
            )
        })
    }

    return (
        <Table
            config={{
                controls: [<Button roles={userRoles.editProducts} onClick={addNewProduct}>Add New Product</Button>],
                data: products,
                headers: [
                    {
                        label: 'Name',
                        propKey: 'name',
                    }, {
                        label: 'Product Types',
                        propKey: 'appProductType',
                        options: true,
                        sortBy: true,
                    }, {
                        label: 'Price',
                        propKey: 'price',
                        type: 'number'
                    }, {
                        label: 'Value',
                        propKey: 'value',
                        type: 'number'
                    }, {
                        label: 'Active',
                        propKey: 'enabled',
                        options: true,
                    },
                ],
                renderFormat: (e) => (
                    <ManagementRow
                        key={generateId()}
                        controls={[
                            <Button roles={userRoles.editProducts} key={generateId()} onClick={() => editProduct(e)}>Edit</Button>,
                            <Button roles={userRoles.editProducts} key={generateId()} onClick={() => deleteProduct(e)}>Delete</Button>
                        ]}
                    >
                        <td>{e.name}</td>
                        <td>{translate(e.appProductType)}</td>
                        <td>{formatCurrency(e.price)}</td>
                        <td>{formatCurrency(e.value || e.price)}</td>
                        <Ctd><CheckMark checked={e.enabled} /></Ctd>
                    </ManagementRow>
                )
            }}
        />
    );
}

export default Products;
